import React from "react";

import Router from "app/routes/Router";
import "scss/styles.scss";

const App = (): JSX.Element => {
    return <Router />;
};

export default App;
